import { useState } from 'react'

import { Button, Popconfirm } from 'antd'
import { faCheck, faExclamationTriangle, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../antd/Buttons/IconButton'
import TooltipIconButton from '../../../antd/Buttons/TooltipIconButton'
import ScheduleMessagingButton from '../../../shared/Buttons/ScheduleMessagingButton'
import { isObject } from '../../../../utils'

const INITIAL_VALIDATE_BUTTON_TEXT = 'Submit'
const HOVERING_VALIDATE_BUTTON_TEXT = 'Warning'
const HOVERING_VALIDATE_BUTTON_STYLE = {
  backgroundColor: '#FF7F7F',
  fontWeight: 'bold',
  color: 'white'
}
const INITIAL_VALIDATE_BUTTON_STYLE = {
  backgroundColor: '#3c8dbc',
  fontWeight: 'bold',
  color: 'white'
}

const renderButtonProps = (text, style, icon) => {
  return {
    text,
    icon,
    style: {
      ...style,
      justifyContent: 'center',
      width: '100px'
    }
  }
}

const Footer = ({ hasInvalidHours, loading, shift, useExtendedActions, onClose, onConfirmHours, onDelete, onOpenMessages, onSubmit, isUpdate }) => {
  const t = useSelector(selectTranslate)

  const [validateButton, setValidateButton] = useState(renderButtonProps(
    INITIAL_VALIDATE_BUTTON_TEXT,
    INITIAL_VALIDATE_BUTTON_STYLE,
    faCheck
  ))

  const handleMouseLeave = () => {
    setValidateButton(renderButtonProps(
      INITIAL_VALIDATE_BUTTON_TEXT,
      INITIAL_VALIDATE_BUTTON_STYLE,
      faCheck
    ))
  }

  const handleMouseEnter = () => {
    setValidateButton(renderButtonProps(
      HOVERING_VALIDATE_BUTTON_TEXT,
      HOVERING_VALIDATE_BUTTON_STYLE,
      faExclamationTriangle
    ))
  }

  return (
    <div className='flex-row'>
      {isObject(shift) && <ScheduleMessagingButton shift={shift} onOpen={onOpenMessages} style={{ marginRight: '8px' }} />}
      <div className='flex-fill' />
      {useExtendedActions && (
        <>
          <Popconfirm
            title={t('desiderata_modal.footer.delete_confirmation')}
            onConfirm={onDelete}
            onCancel={onClose}
          >
            <IconButton icon={faTrash} text={t('common.delete')} type='danger' />
          </Popconfirm>
          {hasInvalidHours && (
            <Popconfirm
              cancelText={t('common.cancel')}
              okText={t('common.yes')}
              onConfirm={onConfirmHours}
              placement='top'
              title={t('student_internship_shift.invalid_act_hours.confirmation')}
            >
              <TooltipIconButton
                disabled={false}
                icon={validateButton.icon}
                loading={loading}
                placement='bottom'
                style={validateButton.style}
                text={t(validateButton.text)}
                title={t('student_acts.invalid_hours_total')}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              />
            </Popconfirm>
          )}
          {!hasInvalidHours && (
            <IconButton
              icon={faCheck}
              style={validateButton.style}
              text={t('common.ok')}
              type='primary'
              onClick={onConfirmHours}
            />
          )}
        </>
      )}
      <Button onClick={onClose}> {t('common.cancel')} </Button>
    </div>
  )
}

export default Footer
